import { useState, type FormEvent } from 'react';
import { AdminDialog } from '@realrain/ui/admin';
import { api } from './api';
import './registration-invites.css';

type Invite = { code: string; label: string; enabled: boolean; registrations: number; registrationUrl: string };

export function RegistrationInvites({ onSelect }: { onSelect(code: string): void }) {
  const [open,setOpen]=useState(false),[items,setItems]=useState<Invite[]>([]);
  const [loading,setLoading]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState(''),[notice,setNotice]=useState('');
  const [code,setCode]=useState(''),[label,setLabel]=useState(''),[createOpen,setCreateOpen]=useState(false),[link,setLink]=useState('');
  async function load() {
    setLoading(true);
    try { setItems((await api<{items:Invite[]}>('/api/v1/admin/registration-invites')).items); }
    catch(e) { setError((e as Error).message); }
    finally { setLoading(false); }
  }
  async function create(event:FormEvent) {
    event.preventDefault(); if(busy)return;
    setBusy(true);setError('');setNotice('');
    try {
      await api('/api/v1/admin/registration-invites',{method:'POST',body:JSON.stringify({code,label})});
      setCode('');setLabel('');setCreateOpen(false);await load();
    } catch(e) { setError((e as Error).message); } finally { setBusy(false); }
  }
  async function toggle(item:Invite) {
    if(busy)return;setBusy(true);setError('');setNotice('');
    try {
      await api('/api/v1/admin/registration-invites/'+encodeURIComponent(item.code),{method:'PATCH',body:JSON.stringify({enabled:!item.enabled})});
      await load();
    } catch(e) { setError((e as Error).message); } finally { setBusy(false); }
  }
  async function copy(item:Invite) {
    setNotice('');setLink('');
    try { await navigator.clipboard.writeText(item.registrationUrl);setNotice('链接已复制'); }
    catch { setLink(item.registrationUrl); }
  }
  return <>
    <button onClick={()=>{setOpen(true);setError('');setNotice('');setLink('');void load();}}>邀请码</button>
    <AdminDialog open={open} onOpenChange={setOpen} busy={busy} title="邀请码" description="按新增统一账号统计">
      <div className="registration-invites">
        {error&&<div className="error" role="alert">{error}</div>}
        {notice&&<p className="muted" role="status">{notice}</p>}
        {link&&<input aria-label="注册链接" readOnly value={link} autoFocus onFocus={event=>event.currentTarget.select()}/>}
        <div className="invite-list" aria-busy={loading}>
          {items.map(item=><div className="invite-row" key={item.code}>
            <div className="invite-identity"><b>{item.label}</b><small><code>{item.code}</code>{!item.enabled&&' · 已停用'}</small></div>
            <button className="invite-count" onClick={()=>{onSelect(item.code);setOpen(false);}} aria-label={`查看 ${item.code} 的 ${item.registrations} 个注册账号`}>{item.registrations} 人</button>
            <div className="invite-actions"><button disabled={!item.enabled} onClick={()=>void copy(item)}>复制链接</button><button disabled={busy} onClick={()=>void toggle(item)}>{item.enabled?'停用':'启用'}</button></div>
          </div>)}
          {!items.length&&<p className="muted">{loading?'正在加载…':'暂无邀请码'}</p>}
        </div>
        <details open={createOpen} onToggle={event=>setCreateOpen(event.currentTarget.open)}>
          <summary>新建邀请码</summary>
          <form className="invite-create" onSubmit={create}><fieldset disabled={busy}>
            <label>来源名称<input required maxLength={80} value={label} onChange={event=>setLabel(event.target.value)} placeholder="合作方名称"/></label>
            <label>邀请码<input required minLength={3} maxLength={32} pattern="[A-Za-z0-9][A-Za-z0-9_\-]{2,31}" autoCapitalize="characters" spellCheck={false} value={code} onChange={event=>setCode(event.target.value.toUpperCase())} placeholder="PARTNERA"/></label>
            <div className="console-form-actions"><button className="primary" disabled={busy}>{busy?'保存中…':'创建'}</button></div>
          </fieldset></form>
        </details>
      </div>
    </AdminDialog>
  </>;
}
